import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { StockCountHistoryAction } from './stock-count-history.actions';
import {
  StockCountHistoryListContent,
  StockCountHistorySearchCriteria,
  StockCountHistoryViewResponse
} from '../../model/stock-count-history.model';

export interface StockCountHistoryState extends EntityState<StockCountHistoryListContent> {
  isLoading: boolean;
  selected: any[];
  criteriaObject: StockCountHistorySearchCriteria;
  totalElements: number;
  totalPages: number;
  auditLogs: any;
  viewResponse: StockCountHistoryViewResponse;
}

export const adapter: EntityAdapter<StockCountHistoryListContent> = createEntityAdapter<StockCountHistoryListContent>(
  {
    selectId: (model: StockCountHistoryListContent) => model.docNo
  }
);

export const initialState: StockCountHistoryState = adapter.getInitialState({
  isLoading: false,
  selected: [],
  criteriaObject: {
    page: 0,
    size: 20
  },
  totalElements: null,
  totalPages: 20,
  auditLogs: [],
  viewResponse: null
});

export const StockCountHistoryReducer = createReducer<StockCountHistoryState>(
  initialState,
  on(StockCountHistoryAction.responseList, (state, action): StockCountHistoryState => {
    return {
      ...state,
      selected: action.data.content,
      totalElements: action.data.totalElements,
      isLoading: false,
      criteriaObject: {
        ...state.criteriaObject,
        page: action.data.page,
        size: action.data.size
      }
    };
  })
);
